export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
    seriesError: 'Vous devez sélectionner au moins une option',
  },
  calculator: {
    title: "Calculer l'épargne en Walutomat",
    forBuy: 'pour',
    unsupportedPair: "Nous n'offrons pas actuellement de taux pour la paire de devises sélectionnée.",
    spinnerError: {
      generic: 'Il y a eu un problème avec le téléchargement des données',
      toManyRequests:
        'Le calculateur est actuellement indisponible. Veuillez réessayer plus tard ou contacter le <a href="https://www.walutomat.com/fr/contact/">Service Client</a>.',
    },
    commissionWT: 'Commission Walutomat',
    ctaButton: 'Échanger',
    amountText: 'Montant',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Vérifiez les taux et changez vos devises dans Walutomat – rapidement et à des conditions avantageuses.',
    actualRate: 'Taux actuel',
    buySelect: "Valeur de l'échange",
    sellSelect: 'Je vends',
    exchangeAmountSellLabel: 'Vous recevrez',
    exchangeAmountBuyLabel: 'Acompte',
    commission: 'Commission promotionnelle ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Le champ ne peut pas être vide',
    requiredField: 'Le champ est obligatoire',
    requireAllFields: 'Tous les champs doivent être remplis',
    passwordToShort: 'Le mot de passe doit comporter 8 caractères',
    emailNotValid: 'Le champ doit contenir une adresse électronique valide',
    emailReserved: "L'adresse électronique est déjà prise",
    emailUnregistered: "Nous n'avons pas trouvé votre adresse e-mail dans notre base de données clients.",
    markField: 'Cochez au moins une des cases',
    serverUnknownError: 'Erreur de communication avec le serveur',
    invalidCharacters: 'Le champ contient des caractères non valides',
    phoneNotValid: 'Le numéro de téléphone est incorrect',
    checkBoxBelow: 'Veuillez cocher la case ci-dessous pour envoyer un message',
    promocodeInvalid: 'Code promotionnel invalide',
    newsletterAlreadySubscribed: 'Cet e-mail est déjà abonné à la newsletter.',
  },
  password: {
    show: 'afficher',
    hide: 'cacher',
  },
  howItWorks: {
    showButton: 'Afficher plus',
    hideButton: 'Afficher moins',
  },
  rateCalculator: {
    baseInputLabel: 'Mam',
    counterInputLabel: 'Otrzymam',
    counterInputTooltip: 'Uwzględnia prowizję {{commission}}%',
    ctaAlert: 'Ustaw alert',
  },
  esim: {
    searchPlaceholder: 'Rechercher un pays ou une région...',
    searchAriaLabel: 'Rechercher un pays ou une région',
    searchMinChars: 'Saisissez <b>au moins 3 caractères</b> pour afficher les résultats.',
    searchNoResults: '<b>Aucun résultat.</b> Le pays recherché est introuvable.',
    searchError: '<b>Une erreur est survenue.</b> Impossible de charger la liste des offres.',
  },
}
